import React from 'react';
import ReactBSAlert from 'react-bootstrap-sweetalert';

const SweetAlerts = ({
  type = 'success',
  title,
  text,
  children,
  onConfirm,
  confirmBtnText,
  onCancel
}) => (
  <ReactBSAlert
    type={type}
    style={{ display: 'block', marginTop: '-100px' }}
    title={title}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmBtnBsStyle={type}
    confirmBtnText={confirmBtnText || 'OK'}
    contentClassName="big"
    confirmBtnCssClass="btn btn-success"
    confirmBtnStyle={{
      boxShadow: 'none'
    }}
    // customButtons={
    //   <>
    //     <Button>Stäng</Button>
    //   </>
    // }
  >
    {children || ''}
    {/* eslint-disable-next-line react/no-danger */}
    {text && <p className="mb-0" dangerouslySetInnerHTML={{ __html: text }} />}
  </ReactBSAlert>
);

export default SweetAlerts;
